// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/flag-icons/css/flag-icons.min.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-button, .list-name-selector {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-button, .list-name-selector {
  display: flex;
  flex-direction: column;
}

.rDNA-button, .list-name-selector {
  justify-content: center;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.top-matter-container {
  height: -moz-fit-content;
  height: fit-content;
}

.interactive {
  cursor: pointer;
}

.raised-footer {
  display: flex;
  justify-content: center;
  padding: 4px;
  background-color: #e1e3e4;
  border-top: 1px solid #ddd;
  width: 100%;
}

.view-toggle-btn {
  padding: 10px 20px;
  background-color: #0CAD99;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-toggle-btn:hover {
  background-color: white;
  color: #0CAD99;
}

.ret-profile-container {
  display: flex;
  flex-direction: column;
}

.buttons-export {
  display: flex;
  justify-content: right;
  width: 100%;
  margin: 0 10% 0 0;
}
.buttons-export .button-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.buttons-export button {
  border: none;
  border-radius: 5px;
  margin: 0 10px 0 0;
  font-size: 15px;
  padding: 7px 14px;
}
.buttons-export .share-btn {
  background-color: #1B3E78;
  color: white;
  cursor: pointer;
}
.buttons-export .compare-btn {
  background-color: #0CAD99;
  color: white;
  cursor: pointer;
  display: flex;
}
.buttons-export .compare-btn span {
  padding-left: 5px;
}

.share-btn:hover {
  opacity: 0.8;
}

.compare-btn:hover {
  opacity: 0.8;
}

.buttons-export-mobile, .header-title-chips-mobile, .header-title-label-mobile, .selected-chips-mobile {
  display: none;
}

.topmatter {
  display: flex;
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 30px;
}

.mobilewrap-1 {
  width: 30%;
  min-width: 350px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  display: flex;
}

.col-1 {
  display: flex;
  flex-direction: column;
  width: 40%;
  min-width: 160px;
  margin-right: 10px;
}
.col-1 .col-1-top {
  display: flex;
  min-width: 160px;
  flex-direction: column;
  align-content: center;
  width: 160px;
}
.col-1 .logo {
  display: flex;
  align-items: center;
  height: 150px;
  border-radius: 5px;
  padding: 5px;
}
.col-1 .logo .retailer-img {
  max-height: 150px;
  max-width: 150px;
  object-fit: cover;
}
.col-1 .social {
  margin: 15px 5px 15px 5px;
}
.col-1 .social svg {
  width: 16.6%;
  height: 20px;
  color: #4c4c47;
}
.col-1 .col-1-links {
  width: 160px;
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 5px;
}
.col-1 .lp {
  display: flex;
  align-items: center;
}
.col-1 .lp a {
  text-decoration: none;
  color: #4c4c47;
  font-size: 13px;
  padding-left: 5px;
}
.col-1 .lp span {
  font-size: 15px;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
  color: #4c4c47;
}
.col-1 .corporation_name {
  color: #4c4c47;
  font-size: 13px;
}
.col-1 .corporation_name p {
  text-align: left;
}

.col-2 {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 0 10px 0 10px;
  width: 60%;
  max-width: 160px;
}
.col-2 h1 {
  color: #4c4c47;
  font-size: 25px;
  font-weight: 600;
  text-wrap: nowrap;
}
.col-2 .details div {
  display: flex;
  align-items: center;
  padding: 3px 0 3px 0;
}
.col-2 .details div span {
  font-size: 20px;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 11;
  color: #7D7979;
}
.col-2 .details div p {
  font-size: 15px;
  margin: 3px 0 0 3px;
  color: #7D7979;
  text-align: left;
}
.col-2 .details .hq img {
  border-radius: 100%;
  height: 13px;
  width: 13px;
  padding-left: 3px;
  padding-right: 4px;
}

.mobilewrap-2 {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.col-3 {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 40px 20px 10px 0px;
}
.col-3 .description p {
  color: #4c4c47;
  font-size: 13px;
  font-weight: 200;
}
.col-3 .markets, .col-3 .sector, .col-3 .categories {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  max-width: 100vw;
}
.col-3 .markets h3, .col-3 .sector h3, .col-3 .categories h3 {
  color: #4c4c47;
  font-size: 13px;
  font-weight: 500;
  padding-right: 5px;
  margin: 0;
}
.col-3 .markets p, .col-3 .sector p, .col-3 .categories p {
  color: #7D7979;
  font-size: 13px;
  margin: 0;
}
.col-3 .sector p, .col-3 .categories p {
  background-color: rgba(170, 204, 255, 0.4666666667);
  padding: 2px 10px 2px 10px;
  border-radius: 10px;
  text-align: left;
  text-wrap: nowrap;
}
.col-3 .metrics {
  display: flex;
}
.col-3 .metrics div {
  display: flex;
}
.col-3 .metrics, .col-3 .rankings {
  display: flex;
  margin-top: 15px;
}
.col-3 .metrics div, .col-3 .rankings div {
  display: flex;
  align-items: center;
  width: 40%;
  margin: 10px 10px 0 10px;
}
.col-3 .metrics div h3, .col-3 .rankings div h3 {
  color: #4c4c47;
  font-size: 12px;
  font-weight: 500;
  padding-right: 5px;
  margin: 0;
  width: 45%;
  text-align: start;
}
.col-3 .metrics div span, .col-3 .rankings div span {
  font-size: 12px;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
  cursor: default;
}
.col-3 .metrics div p, .col-3 .rankings div p {
  color: #7D7979;
  font-size: 12px;
  margin: 0;
}
.col-3 .metrics div .value, .col-3 .rankings div .value {
  padding: 4px 5px 4px 5px;
  width: 30%;
}
.col-3 .metrics div .negative, .col-3 .rankings div .negative {
  color: red;
  font-size: 8px;
  padding: 0;
  padding-left: 5px;
}
.col-3 .metrics div .positive, .col-3 .rankings div .positive {
  color: #00b300;
  font-size: 8px;
  padding: 0;
  padding-left: 5px;
}
.col-3 .metrics .web-traffic .value, .col-3 .rankings .web-traffic .value {
  background-color: rgba(255, 191, 0, 0.0705882353);
  border-radius: 5px;
  color: #d29e03;
}
.col-3 .metrics .revenue .value, .col-3 .rankings .revenue .value {
  background-color: rgba(12, 173, 154, 0.0745098039);
  border-radius: 5px;
  color: #0CAD99;
}
.col-3 .metrics .profit .value, .col-3 .rankings .profit .value {
  background-color: rgba(27, 63, 120, 0.0901960784);
  border-radius: 5px;
  color: #1B3E78;
}
.col-3 .rankings .value {
  background-color: rgba(125, 121, 121, 0.0666666667);
  border-radius: 5px;
  color: #7D7979;
}
.col-3 .rankings span {
  margin-right: 20px;
}

.products {
  width: 75vw;
  display: flex;
  flex-direction: column;
  background-color: white;
}
.products .products-title {
  width: 100%;
  text-align: center;
  background-color: #1B3E78;
  color: white;
}
.products .products-table, .products .product-row, .products .product-lists {
  display: flex;
  width: 100%;
}
.products .product-row {
  width: 100%;
  justify-content: space-between;
}
.products .product-sector {
  width: 15%;
}
.products .product-name {
  width: 15%;
}
.products .product-lists {
  width: 70%;
}

.mobilewrap-3 {
  width: 15%;
  display: flex;
}

.col-4-mobile {
  display: none;
}

.col-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0px 10px 0px;
  width: 100px;
}
.col-4 .title h2 {
  color: #4c4c47;
  font-size: 13px;
  font-weight: 350;
}
.col-4 .list-button:hover {
  cursor: pointer;
  background-color: #0CAD99 !important;
  transition: all, 0.5s;
}
.col-4 .list-button:hover a {
  color: white !important;
  transition: all, 0.5s;
}
.col-4 .buttons button {
  background-color: white;
  color: #0CAD99;
  border: 2px solid #0CAD99;
  border-radius: 5px;
  margin-bottom: 3px;
  padding: 5px;
}
.col-4 .buttons button a {
  color: #0CAD99;
  text-decoration: none;
  font-size: 12px;
}
.col-4 .vendor-social {
  display: flex;
  flex-direction: column;
}
.col-4 .vendor-social div, .col-4 .vendor-social a {
  display: flex;
  align-items: center;
}
.col-4 .vendor-social a {
  cursor: pointer;
}
.col-4 .vendor-social span {
  font-size: 15px;
  margin-right: 5px;
}
.col-4 .vendor-social p {
  font-size: 10px;
}

.echelon-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.echelon {
  transition: width 0.3s ease;
  margin-bottom: 30px;
}

.mobile {
  display: none;
}

.linkedin {
  margin-top: 10px;
}
.linkedin svg {
  margin-right: 5px;
}

.email a {
  text-decoration: none;
}
.email span {
  color: black;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 20px;
}

.tooltip-trigger {
  /*cursor: nw-resize;*/
}

.tooltip-box {
  position: fixed; /* or 'absolute' if you want it to follow a parent */
  max-width: 200px;
  background-color: white;
  color: #4c4c47;
  padding: 16px 20px;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);
  font-size: 13px;
  text-align: justify;
  white-space: normal; /* ✅ Allow wrapping */
  word-wrap: break-word; /* ✅ Wrap long words if needed */
  overflow-wrap: break-word;
  z-index: 1000; /* Make sure it's high enough */
  pointer-events: none; /* Important: allows hover to still hit the trigger */
  transition: opacity 0.2s ease;
}

.export-dropdown-container {
  position: relative;
}

.export-dropdown {
  position: absolute;
  z-index: 99;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);
  width: 250px;
  border-radius: 3px;
  transform: translateX(-33%);
}

.export-btn-container {
  padding: 16px 20px;
  background-color: white;
  color: #4c4c47;
}
.export-btn-container span {
  font-size: 15px;
}

.export-btn-container:hover {
  background-color: #e7e7e7;
  cursor: pointer;
}

.header-title-chips {
  width: 100%;
  padding: 10px;
  border-radius: 12px;
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  text-align: center;
  margin-right: 20px;
}

.header-title-label {
  font-weight: bold;
  font-size: 14px;
  margin: 0 20px;
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.selected-chips .chip {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 12px;
  padding: 7px 10px;
  font-size: 14px;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.selected-chips .chip--retailer {
  border: 2px solid #1B3E78;
}
.selected-chips .chip--ranking {
  border: 2px solid #0CAD99;
}
.selected-chips .chip--sector {
  border: 2px solid #3792BF;
}
.selected-chips .chip--cluster {
  border: 2px solid #AACCFF;
}
.selected-chips .chip .remove-chip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.selected-chips .chip .remove-chip:hover {
  color: #333;
}

@media (max-width: 1300px) {
  .col-3 {
    width: 30dvw;
  }
  .col-3 .metrics, .col-3 .rankings {
    flex-wrap: wrap;
    overflow: visible;
  }
  .col-4-mobile {
    display: flex;
  }
  .col-4-mobile .title {
    display: flex;
    align-items: center;
    margin-top: 15px;
  }
  .col-4-mobile .title h2 {
    color: #4c4c47;
    font-size: 13px;
    font-weight: 350;
    margin-right: 10px;
  }
  .col-4-mobile .buttons button {
    background-color: white;
    color: #0CAD99;
    border: 2px solid #0CAD99;
    border-radius: 5px;
    margin-bottom: 3px;
    padding: 5px;
  }
  .col-4-mobile .buttons button a {
    color: #0CAD99;
    text-decoration: none;
    font-size: 12px;
  }
  .col-4 {
    display: none;
  }
}
@media (max-width: 1000px) {
  .ret-profile-container {
    width: 70vw;
  }
  .topmatter {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .topmatter .mobilewrap-1, .topmatter .mobilewrap-2, .topmatter .mobilewrap-3 {
    width: 60vw;
  }
  .topmatter .col-3 {
    padding: 0;
  }
  .topmatter .col-3 .metrics h3, .topmatter .col-3 .metrics P, .topmatter .col-3 .rankings h3, .topmatter .col-3 .rankings P {
    width: 60%;
    font-size: 11px;
  }
  .topmatter .social {
    width: 60vw;
    padding-top: 15px;
  }
  .topmatter .col-1-links {
    width: 100vw;
    flex-direction: row;
    justify-content: space-between;
  }
  .topmatter .list-button {
    margin-left: 15px;
  }
  .col-3 {
    width: 100dvw;
  }
}
@media (max-width: 774px) {
  .ret-profile-container {
    width: 100vw;
  }
  .topmatter {
    flex-direction: column;
  }
  .topmatter .mobilewrap-1, .topmatter .mobilewrap-2, .topmatter .mobilewrap-3 {
    width: 85vw;
    padding: 2vw 5vw 0 5vw;
  }
  .topmatter .col-1 {
    width: 50%;
  }
  .topmatter .col-1 .col-1-top {
    min-width: 150px;
    width: 150px;
  }
  .topmatter .col-1 .logo {
    height: 150px;
    border-radius: 5px;
  }
  .topmatter .col-1 .logo .retailer-img {
    max-height: 140px;
    max-width: 140px;
    object-fit: cover;
  }
  .topmatter .col-1 .social {
    width: 95dvw;
    margin: 30% 0 0 0;
  }
  .topmatter .col-1 .social svg {
    width: 15%;
    height: 30px;
    color: #4c4c47;
  }
  .topmatter .col-1 .col-1-links {
    margin-top: 5vw;
    width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: start;
  }
  .topmatter .col-1 .col-1-links .corporation_name {
    display: flex;
  }
  .topmatter .col-1 .col-1-links .corporation_name p {
    color: #4c4c47;
    font-size: 15px;
    margin-left: 10px;
  }
  .topmatter .col-1 .col-1-links .lp {
    display: flex;
    align-items: center;
  }
  .topmatter .col-1 .col-1-links .lp a {
    text-decoration: none;
    color: #4c4c47;
    font-size: 18px;
    padding-left: 5px;
  }
  .topmatter .col-1 .col-1-links .lp span {
    font-size: 25px;
    font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
    color: #4c4c47;
  }
  .topmatter .col-3 .metrics h3, .topmatter .col-3 .metrics P, .topmatter .col-3 .rankings h3, .topmatter .col-3 .rankings P {
    width: 22%;
    font-size: 11px;
  }
  .col-2 {
    width: 50%;
    height: -moz-fit-content;
    height: fit-content;
  }
  .col-2 h1 {
    color: #4c4c47;
    font-size: 15px;
    font-weight: 600;
    text-wrap: wrap;
  }
  .col-2 .details div span {
    font-size: 20px;
    font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 11;
    color: #7D7979;
  }
  .col-2 .details div p {
    font-size: 12px;
    margin: 3px 0 0 3px;
    color: #7D7979;
    text-align: left;
  }
  .col-2 .details .hq img {
    border-radius: 100%;
    height: 15px;
    width: 15px;
  }
  .col-3 {
    width: 80dvw;
  }
  .col-3 .metrics, .col-3 .rankings, .col-3 .categories {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .col-3 .metrics h3, .col-3 .metrics P, .col-3 .rankings h3, .col-3 .rankings P, .col-3 .categories h3, .col-3 .categories P {
    width: 30%;
    font-size: 11px;
  }
  .col-3 .metrics .web-traffic h3, .col-3 .metrics .profit h3, .col-3 .metrics .revenue h3, .col-3 .metrics .list-1 h3, .col-3 .metrics .list-2 h3, .col-3 .metrics .list-3 h3, .col-3 .rankings .web-traffic h3, .col-3 .rankings .profit h3, .col-3 .rankings .revenue h3, .col-3 .rankings .list-1 h3, .col-3 .rankings .list-2 h3, .col-3 .rankings .list-3 h3, .col-3 .categories .web-traffic h3, .col-3 .categories .profit h3, .col-3 .categories .revenue h3, .col-3 .categories .list-1 h3, .col-3 .categories .list-2 h3, .col-3 .categories .list-3 h3 {
    font-size: 13px;
    width: 22%;
  }
  .col-3 .metrics div, .col-3 .rankings div, .col-3 .categories div {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 0 10px 0;
  }
  .col-3 .metrics div span, .col-3 .rankings div span, .col-3 .categories div span {
    font-size: 15px;
    font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
  }
  .col-3 .metrics div p, .col-3 .rankings div p, .col-3 .categories div p {
    color: #7D7979;
    font-size: 15px;
    margin: 0;
  }
  .col-3 .metrics div .value, .col-3 .rankings div .value, .col-3 .categories div .value {
    text-align: center;
    padding: 4px 5px 4px 5px;
    width: 70dvw;
    font-size: 13px;
  }
  .col-3 .metrics div .negative, .col-3 .rankings div .negative, .col-3 .categories div .negative {
    font-size: 12px;
    width: 7%;
  }
  .col-3 .metrics div .positive, .col-3 .rankings div .positive, .col-3 .categories div .positive {
    font-size: 12px;
    width: 7%;
  }
  .col-3 .categories p {
    margin: 5px;
  }
  .mobile {
    display: flex;
  }
  .buttons-export {
    display: none;
  }
  .buttons-export-mobile {
    display: flex;
    width: 75vw;
    justify-content: space-evenly;
    margin-top: 20%;
    margin-left: 12%;
  }
  .buttons-export-mobile button {
    border: none;
    width: 33vw;
    border-radius: 5px;
    font-size: 15px;
    padding: 10px 20px 10px 20px;
  }
  .buttons-export-mobile .share-btn {
    background-color: #1B3E78;
    color: white;
  }
  .buttons-export-mobile .compare-btn {
    background-color: #0CAD99;
    color: white;
    padding-left: 20%;
    display: flex;
  }
  .header-title-chips-mobile {
    padding: 10px;
    margin-top: 20px;
    width: 79vw;
    border-radius: 12px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .header-title-label-mobile {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 6px;
    margin-right: auto;
    align-self: flex-start;
    display: flex;
  }
  .selected-chips-mobile {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
  }
  .selected-chips-mobile .chip {
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 12px;
    padding: 4px 10px;
    font-size: 14px;
    color: #333;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  .selected-chips-mobile .chip--retailer {
    border: 2px solid #1B3E78;
  }
  .selected-chips-mobile .chip--ranking {
    border: 2px solid #0CAD99;
  }
  .selected-chips-mobile .chip--sector {
    border: 2px solid #3792BF;
  }
  .selected-chips-mobile .chip--cluster {
    border: 2px solid #AACCFF;
  }
  .selected-chips-mobile .chip .remove-chip {
    margin-left: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
  }
  .selected-chips-mobile .chip .remove-chip:hover {
    color: #333;
  }
  .export-dropdown-container-mobile {
    position: relative;
  }
  .export-dropdown-mobile {
    position: absolute;
    z-index: 99;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);
    border-radius: 3px;
  }
}
.list-profile-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 30px;
}

.list-top-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.list-profile-header {
  display: flex;
  margin-bottom: 5px;
  align-items: flex-start;
  justify-content: space-between;
}

.list-banner {
  display: flex;
  width: 100%;
  flex-direction: row;
  height: -moz-fit-content;
  height: fit-content;
  border: solid 1px #0CAD99;
  border-radius: 25px;
  padding: 20px;
  background-color: white;
  justify-content: space-between;
}

.list-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.sponsor-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 70%;
}

.sponsor-text-container {
  height: 30%;
}
.sponsor-text-container p {
  text-align: center;
  font-size: 12px;
}

.sponsor-icon-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.sponsor-icon-container img {
  margin: 10px;
  max-height: 40px;
  min-width: 45px;
  width: 80px;
  object-fit: contain;
}

.like-profile {
  grid-column: 3;
  grid-row: 1;
}

.compare-profile, .share-profile {
  cursor: pointer;
  transition: background-color 0.3s;
}

.compare-profile {
  background-color: #1B3E78;
  color: white;
  border: 2px solid #1B3E78;
  border-radius: 5px;
  padding: 10px 20px;
  margin-right: 10px;
}
.compare-profile p {
  color: white;
  margin: 0;
}
.compare-profile:hover {
  background-color: #fff;
  color: #1B3E78;
}
.compare-profile:hover p {
  color: #1B3E78;
}

.share-profile {
  border-radius: 100%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  padding: 10px;
  margin-right: 30px;
}
.share-profile span {
  font-size: 40px;
}
.share-profile:hover {
  box-shadow: 0 0 20px rgba(12, 173, 153, 0.8);
  background-color: rgba(12, 173, 153, 0.3);
}
.share-profile:active {
  background-color: #BDBDBD;
  transition: none;
}

.list-cluster {
  border-radius: 10px;
  margin: 10px 0;
  background-color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.list-cluster-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}

.elite-table {
  table-layout: fixed;
  width: 100%;
  padding: 0 5%;
  border-collapse: separate;
  border-spacing: 0 1em;
}
.elite-table tr:first-child {
  background-color: white;
}
.elite-table tr {
  background-color: #F4F7FE;
}
.elite-table th {
  width: 14%;
}
.elite-table .elite-td {
  text-align: center;
  align-items: center;
  padding: 1px 0;
  border-bottom: none;
  margin: auto;
}
.elite-table .elite-td p {
  text-align: center;
  margin: 0;
}

.list-cluster-title-container {
  display: flex;
}

.list-cluster-title {
  font-size: 25px;
  margin: 10px;
  font-weight: bold;
}

.list-cluster-title-name {
  color: #0CAD99;
  font-size: 25px;
  margin: 10px;
  font-weight: bold;
}

.retailer-logo {
  height: auto;
}

.retailer-leading {
  font-size: 15px;
  font-weight: bold;
}

.retailer-top {
  font-size: 13px;
}

.retailer-rest {
  font-size: 11px;
}

.list-prof-pill {
  border-radius: 10px;
  margin: 3px;
  padding: 5px 7px;
  transition: background-color 0.3s ease-out;
}
.list-prof-pill p {
  margin: 0;
  color: #2D2D2A;
  text-align: center;
}
.list-prof-pill a {
  color: #2D2D2A;
}
.list-prof-pill:hover {
  background-color: #0CAD99;
  color: white;
  cursor: pointer;
}
.list-prof-pill:hover p {
  color: white;
}
.list-prof-pill:active {
  background-color: #BDBDBD;
  transition: none;
}

.list-lists,
.list-other-clusters {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.list-name {
  width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
}

.list-name-selector-form {
  display: flex;
  flex-direction: row;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 55%;
  max-height: 75%;
}

.list-name-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 225px;
  padding: 10px;
  border-radius: 15px;
  transition: background-color 0.3s ease-out;
  white-space: normal;
  overflow-wrap: break-word !important;
  background-color: #3792BF;
  color: white;
  border: none;
}
.list-name-selector option {
  font-size: 20px;
  background-color: white;
  text-wrap: wrap;
  white-space: normal;
}
.list-name-selector:hover {
  background-color: #e7e7e7;
}
.list-name-selector:active {
  background-color: rgba(12, 173, 153, 0.8);
  transition: none;
}

.flag-icon {
  width: 250px;
  height: 100px;
}

.list-profile-container .chart {
  width: 400px;
  height: 600px;
}

.profile-table {
  width: 100%;
  border-bottom: 1px solid #ccc;
  border-collapse: collapse;
}
.profile-table td {
  border-bottom: 1px solid #ccc;
  padding: 10px;
  width: 50%;
}
.profile-table tr {
  padding: 10px;
}
.profile-table tr a {
  display: flex;
  align-items: center;
  text-decoration: none;
  width: -moz-fit-content;
  width: fit-content;
}
.profile-table tr a span {
  margin-right: 3px;
  font-size: 20px;
  color: #2D2D2A;
}

.table-container {
  width: 100%;
  margin-left: 30px;
}

.table-logo-container {
  display: flex;
  justify-content: center;
  height: 30px;
}

.table-logo {
  display: block;
  width: 80px;
  height: 30px;
  object-fit: contain;
}

.sm-flag-icon {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.table-expand-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1B3E78;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 10px 10px 10px rgba(231, 231, 231, 0.7);
  margin-bottom: 10px;
  max-width: 95vw;
}
.table-expand-button span {
  color: white;
  margin-left: 5px;
}
.table-expand-button p {
  color: #fff;
  font-weight: bold;
}

h1 {
  color: #2D2D2A;
}

.heading {
  text-align: center;
}
.heading a {
  color: #2D2D2A;
}

.pill-container {
  display: flex;
  flex-wrap: wrap;
}

.major-market-pill {
  width: -moz-fit-content;
  width: fit-content;
  margin: 3px;
  padding: 5px;
}

.echelon-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.echelon {
  transition: width 0.3s ease;
  margin-top: 20px;
}

.disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.disabled:hover {
  background-color: #ccc;
  opacity: 0.5;
}

.crumbtrail p {
  margin: 0;
}

.active-crumb {
  color: #1B3E78;
  font-weight: bolder;
}

.inactive-crumb {
  color: black;
}

.list-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 20px;
  margin-left: 30px;
  justify-content: space-evenly;
}
.list-buttons div {
  width: -moz-fit-content;
  width: fit-content;
}

.rDNA-button {
  border-radius: 15px;
  border: none;
  font-size: 16px;
  height: 48px;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  width: 225px;
}
.rDNA-button:last-of-type {
  margin-bottom: 5px;
}
.rDNA-button span {
  margin-left: 10px;
}
.rDNA-button:hover {
  opacity: 0.8;
  cursor: pointer;
}

.list-share-btn {
  color: #fff;
  background: #3792BF;
}

.compare-btn {
  color: #fff;
  background: #0CAD99;
  margin-left: 10px;
}

.data-btn {
  color: #fff;
  background: #3792BF;
  border: none;
  transition: background-color 0.3s ease-out;
}

.datalocked-btn {
  color: #1B3E78;
  background: #e7e7e7;
  border: none;
  transition: background-color 0.3s ease-out;
}

.padlock-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.padlock {
  display: none;
}

.padlock.disabled {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: left;
  background: radial-gradient(circle, rgba(76, 76, 71, 0.3137254902) 70%, rgba(255, 255, 255, 0.3137254902) 100%);
  position: absolute;
  z-index: 2;
}
.padlock.disabled span {
  font-size: 20px;
}
.padlock.disabled .link {
  width: 100%;
  height: 100%;
  align-items: start;
  justify-content: end;
}

.header-title-chips {
  width: 100%;
  padding: 10px;
  border-radius: 12px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.header-title-label {
  font-weight: bold;
  font-size: 14px;
  margin: 0 20px;
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.selected-chips .chip {
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 12px;
  padding: 7px 10px;
  font-size: 14px;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.selected-chips .chip--retailer {
  border: 2px solid #1B3E78;
}
.selected-chips .chip--ranking {
  border: 2px solid #0CAD99;
}
.selected-chips .chip--sector {
  border: 2px solid #3792BF;
}
.selected-chips .chip--cluster {
  border: 2px solid #AACCFF;
}
.selected-chips .chip .remove-chip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.selected-chips .chip .remove-chip:hover {
  color: #333;
}

.export-dropdown-container {
  position: relative;
}

.export-dropdown-list {
  position: absolute;
  z-index: 99;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);
  border-radius: 3px;
  left: 50%;
  transform: translateX(3%);
  margin-top: 5px;
}

.export-btn-container-list {
  width: 200px !important;
  padding: 16px 20px;
  background-color: white;
  color: #4c4c47;
  box-sizing: border-box;
}
.export-btn-container-list span {
  font-size: 15px;
}

.export-btn-container-list:hover {
  background-color: #e7e7e7;
  cursor: pointer;
}

@media screen and (min-width: 1675px) {
  .echelon-container {
    justify-content: space-between;
  }
  .export-btn-container-list {
    width: 201px !important;
  }
}
@media screen and (max-width: 1439.7px) {
  .list-profile-header {
    align-items: stretch;
  }
  .list-name {
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .list-buttons {
    flex-direction: row;
    align-items: top;
    justify-content: center;
  }
  .list-share-btn {
    margin-right: 10px;
    width: 225px;
  }
  .export-dropdown-list {
    transform: translateX(7%);
    margin-top: 0;
  }
  .export-btn-container-list {
    width: 202px !important;
  }
}
@media screen and (max-width: 1199.7px) {
  .list-name {
    flex-direction: column;
  }
  .list-buttons {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .header-title-chips {
    width: 66vw;
  }
  .buttons-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .list-share-btn, .rDNA-button {
    width: 350px;
  }
  .compare-btn {
    margin-left: 0;
  }
  .export-btn-container-list {
    width: 305px !important;
  }
}
@media screen and (max-width: 1023.7px) {
  .list-name {
    flex-direction: column;
  }
  .list-buttons {
    flex-wrap: nowrap;
    flex-direction: column;
  }
  .list-buttons button {
    margin: 5px 0 5px 0;
  }
  .header-title-chips {
    width: 66vw;
  }
  .export-btn-container-list {
    width: 305px !important;
  }
}
@media (max-width: 767px) {
  .list-profile-container {
    margin: 5px;
  }
  .list-name {
    flex-direction: column;
    align-items: center;
  }
  .list-name-selector-form {
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
  }
  .list-name-selector {
    width: 100%;
    font-size: 20px;
  }
  .list-logo {
    width: 70%;
    margin-left: 10px;
  }
  .flag-icon {
    width: 200px;
    height: 100%;
    margin: 0;
  }
  .list-banner {
    display: flex;
    flex-direction: column;
    height: -moz-fit-content;
    height: fit-content;
    align-items: center;
  }
  .sponsor-area {
    width: 90vw;
  }
  .list-buttons {
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-left: 0;
  }
  .list-buttons div {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }
  .rDNA-button,
  .list-share-btn,
  .compare-btn,
  .data-btn {
    width: 350px;
    margin-right: 0;
  }
  .list-cluster {
    width: 100vw;
  }
  .list-top-container {
    width: 95vw;
  }
  tr {
    border-bottom: 1px solid #e7e7e7;
  }
  .table-container {
    margin-left: 0;
  }
  .profile-table {
    margin: 0;
    width: auto;
  }
  .profile-table th, .profile-table td, .profile-table span, .profile-table p {
    font-size: 11px;
  }
  .table-logo-container {
    margin-left: 0;
    align-items: center;
  }
  .table-logo {
    margin: 0;
    max-width: 100%;
    max-height: 60%;
  }
  .elite-table {
    padding: 0 1%;
    word-wrap: break-word;
  }
  .elite-table th {
    width: 15%;
  }
  .elite-table th:first-child {
    width: 7%;
  }
  .elite-table th:last-child {
    width: 7%;
  }
  .sm-flag-icon {
    width: 20px;
    height: 20px;
  }
  .table-expand-button {
    width: 100vw;
    max-width: 100vw;
  }
  .header-title-chips {
    width: 95vw;
  }
  .export-dropdown-container {
    display: none !important;
  }
  .list-export-dropdown-container-mobile {
    position: relative;
  }
  .list-export-dropdown-mobile {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 0;
    z-index: 99;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.254), 0 3px 10px rgba(0, 0, 0, 0.18);
    border-radius: 3px;
    width: 300px !important;
    flex-direction: column;
  }
  .export-btn-container-list {
    width: 300px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/profile-top-matter/profile-top-matter.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_flexboxes.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;AFEF;AEAE;EACE,4BAAA;AFEJ;AEAI;EACE,YAAA;AFEN;;ACdA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;AHYJ;AGTM;EACE,sHAAA;AHWR;AGPI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;AHSN;AGNI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;AHQN;AGLI;EACE,mBAAA;EACA,sBAAA;AHON;;AGAE;EACE,qCAAA;AHGJ;AGAE;EACE,0BAAA;AHEJ;;AGIE;EACE,0BAAA;AHDJ;AGIE;EACE,uFAAA;AHFJ;;AI3DA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AJ4DA;;AIzDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AJ4DJ;;AIxDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AJyDJ;;AIpDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AJqBR;;AIfA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AJ0Eb;;AIbA;EAAa,YAAA;AJiBb;;AIhBA;EAAO,SAAA;EAAW,iDAAA;AJqBlB;;AIlBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AJmBJ;AIjBI;EACI,YAAA;EACA,SAAA;AJmBR;;AIhBA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AJmBF;;AIhBA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AJmBF;;AIhBA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AJmGb;AIjBI;EACI,cAnFK;AJsGb;;AIfA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AJ8Ff;AIhBE;EACE,cA/EW;AJiGf;;AIdA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AJiBJ;;AKrKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ALwKF;AKrKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ALuKF;AKpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ALsKF;AKnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ALqKF;AKlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ALoKF;AKjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ALmKF;AKhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ALkKF;AK/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ALiKF;AK9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ALgKF;AK7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AL+JF;AK5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AL8JF;AK3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AL6JF;AK1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AL4JF;AKzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AL2JF;AKxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AL0JF;AKvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ALyJF;AKtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ALwJF;AKrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ALuJF;AM3QA;;;;;uBAAA;AC+BA;ECtBE,kCFXY;EEYZ,eDqB2C;ECpB3C,gBAXqF;EAYrF,kBALgB;ARgRlB;;AS7RA;EAC0B,aAAA;EACA,sBAAA;ATgS1B;;ASxRA;EAC0B,uBAAA;EACA,mBAAA;AT2R1B;;AKxSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AL2SF;AKxSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AL0SF;AKvSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ALySF;AKtSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ALwSF;AKrSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ALuSF;AKpSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ALsSF;AKnSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ALqSF;AKlSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ALoSF;AKjSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ALmSF;AKhSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ALkSF;AK/RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ALiSF;AK9RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ALgSF;AK7RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AL+RF;AK5RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AL8RF;AK3RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AL6RF;AK1RA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AL4RF;AKzRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AL2RF;AKxRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AL0RF;AM9YA;;;;;uBAAA;ANCA;EACE,wBAAA;EAAA,mBAAA;AAqZF;;AAhZA;EACE,eAAA;AAmZF;;AAhZA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,WAAA;AAmZF;;AAhZA;EACE,kBAAA;EACA,yBMfW;ENgBX,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAmZF;;AAhZA;EACE,uBAAA;EACA,cMxBW;AN2ab;;AA9YA;EACE,aAAA;EACA,sBAAA;AAiZF;;AA5YA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AA+YF;AA7YE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA+YJ;AA5YE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AA8YJ;AA3YE;EACE,yBMnDS;ENoDT,YAAA;EACA,eAAA;AA6YJ;AA1YE;EACE,yBIfW;EJgBX,YAAA;EACA,eAAA;EACA,aAAA;AA4YJ;AA1YI;EACE,iBAAA;AA4YN;;AAtYA;EACE,YAAA;AAyYF;;AAtYA;EACE,YAAA;AAyYF;;AAtYA;EACE,aAAA;AAyYF;;AAtYA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAyYF;;AAtYA;EACE,UAAA;EACA,gBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,aAAA;AAyYF;;AArYA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EAEA,kBAAA;AAuYF;AArYE;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAuYJ;AApYE;EACE,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,kBAAA;EAIA,YAAA;AAkYJ;AAhYI;EACE,iBAAA;EACA,gBAAA;EAEA,iBAAA;AAiYN;AA7XE;EACE,yBAAA;AA+XJ;AA7XI;EACE,YAAA;EACA,YAAA;EACA,cI5Fa;AJ2dnB;AA3XE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AA6XJ;AAzXE;EACE,aAAA;EACA,mBAAA;AA2XJ;AAzXI;EACE,qBAAA;EACA,cI/Ga;EJgHb,eAAA;EACA,iBAAA;AA2XN;AAtXI;EACE,eAAA;EACA,kEAAA;EAIA,cI5Ha;AJifnB;AAjXE;EACE,cIjIe;EJkIf,eAAA;AAmXJ;AAjXI;EACE,gBAAA;AAmXN;;AA9WA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AAiXF;AA/WE;EACE,cInJe;EJoJf,eAAA;EACA,gBAAA;EACA,iBAAA;AAiXJ;AA5WI;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA8WN;AA5WM;EACE,eAAA;EACA,kEAAA;EAIA,cI3KO;AJshBf;AAxWM;EACE,eAAA;EACA,mBAAA;EACA,cIjLO;EJkLP,gBAAA;AA0WR;AApWM;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAsWR;;AA/VA;EACE,WAAA;EACA,aAAA;EACA,6BAAA;AAkWF;;AA9VA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;AAiWF;AA9VI;EACE,cI9Ma;EJ+Mb,eAAA;EACA,gBAAA;AAgWN;AA5VE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA8VJ;AA5VI;EACE,cI3Na;EJ4Nb,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AA8VN;AA3VI;EACE,cIxOS;EJyOT,eAAA;EACA,SAAA;AA6VN;AAvVI;EACE,mDAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAyVN;AApVE;EACE,aAAA;AAsVJ;AApVI;EACE,aAAA;AAsVN;AAlVE;EACE,aAAA;EACA,gBAAA;AAoVJ;AAlVI;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;AAoVN;AAlVM;EACE,cIxQW;EJyQX,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;AAoVR;AAhVM;EACE,eAAA;EACA,kEAAA;EAIA,eAAA;AA+UR;AA5UM;EACE,cIjSO;EJkSP,eAAA;EACA,SAAA;AA8UR;AAzUM;EACE,wBAAA;EACA,UAAA;AA2UR;AAvUM;EACE,UAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AAyUR;AAtUM;EACE,cAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AAwUR;AAnUM;EACE,iDAAA;EACA,kBAAA;EACA,cAAA;AAqUR;AAhUM;EACE,kDAAA;EACA,kBAAA;EACA,cAAA;AAkUR;AA7TM;EACE,iDAAA;EACA,kBAAA;EACA,cAAA;AA+TR;AAxTI;EACE,mDAAA;EACA,kBAAA;EACA,cAAA;AA0TN;AAvTI;EACE,kBAAA;AAyTN;;AAlTA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAqTF;AAnTE;EACE,WAAA;EACA,kBAAA;EACA,yBMxZS;ENyZT,YAAA;AAqTJ;AAlTE;EACE,aAAA;EACA,WAAA;AAoTJ;AAjTE;EACE,WAAA;EACA,8BAAA;AAmTJ;AA/SE;EACE,UAAA;AAiTJ;AA9SE;EACE,UAAA;AAgTJ;AA7SE;EACE,UAAA;AA+SJ;;AA1SA;EACE,UAAA;EACA,aAAA;AA6SF;;AAzSA;EACE,aAAA;AA4SF;;AAzSA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EACA,YAAA;AA4SF;AAxSI;EACE,cI3Za;EJ4Zb,eAAA;EACA,gBAAA;AA0SN;AAtSE;EACE,eAAA;EACA,oCAAA;EACA,qBAAA;AAwSJ;AAtSI;EACE,uBAAA;EACA,qBAAA;AAwSN;AAlSI;EACE,uBAAA;EACA,cIpbS;EJqbT,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAoSN;AAlSM;EACE,cI3bO;EJ4bP,qBAAA;EACA,eAAA;AAoSR;AA9RE;EACE,aAAA;EACA,sBAAA;AAgSJ;AA9RI;EACE,aAAA;EACA,mBAAA;AAgSN;AA7RI;EACE,eAAA;AA+RN;AA5RI;EACE,eAAA;EACA,iBAAA;AA8RN;AA1RI;EACE,eAAA;AA4RN;;AAvRA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;AA0RF;;AAvRA;EACE,2BAAA;EACA,mBAAA;AA0RF;;AAvRA;EACE,aAAA;AA0RF;;AAvRA;EACE,gBAAA;AA0RF;AAxRE;EACE,iBAAA;AA0RJ;;AArRE;EACE,qBAAA;AAwRJ;AArRE;EACE,YAAA;AAuRJ;;AAnRA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AAsRF;;AAnRA;EACE,qBAAA;AAsRF;;AAlRA;EAIE,eAAA,EAAA,oDAAA;EACA,gBAAA;EACA,uBAAA;EACA,cI3gBiB;EJ4gBjB,kBAAA;EACA,kBAAA;EACA,8EAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA,EAAA,qBAAA;EACA,qBAAA,EAAA,gCAAA;EACA,yBAAA;EACA,aAAA,EAAA,+BAAA;EACA,oBAAA,EAAA,qDAAA;EACA,6BAAA;AAkRF;;AA/QA;EACE,kBAAA;AAkRF;;AA9QA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,8EAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAiRF;;AA7QA;EACE,kBAAA;EACA,uBAAA;EACA,cI5iBiB;AJ4zBnB;AA7QE;EACE,eAAA;AA+QJ;;AA3QA;EACE,yBIpjBgB;EJqjBhB,eAAA;AA8QF;;AA3QA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AA8QF;;AA3QA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AA8QF;;AA3QA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AA8QF;AA5QE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;AA8QJ;AA5QI;EACE,yBAAA;AA8QN;AA3QI;EACE,yBAAA;AA6QN;AA1QI;EACE,yBAAA;AA4QN;AAzQI;EACE,yBAAA;AA2QN;AAxQI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA0QN;AAxQM;EACE,WAAA;AA0QR;;AApQA;EAEE;IACE,YAAA;EAsQF;EApQE;IACE,eAAA;IACA,iBAAA;EAsQJ;EAlQA;IACE,aAAA;EAoQF;EAlQE;IACE,aAAA;IACA,mBAAA;IACA,gBAAA;EAoQJ;EAlQI;IACE,cI5oBW;IJ6oBX,eAAA;IACA,gBAAA;IACA,kBAAA;EAoQN;EA9PI;IACE,uBAAA;IACA,cI3pBO;IJ4pBP,yBAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;EAgQN;EA9PM;IACE,cIlqBK;IJmqBL,qBAAA;IACA,eAAA;EAgQR;EA1PA;IACE,aAAA;EA4PF;AACF;AAzPA;EACE;IACE,WAAA;EA2PF;EAxPA;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;EA0PF;EAxPE;IACE,WAAA;EA0PJ;EAlPE;IACE,UAAA;EAoPJ;EAjPM;IACE,UAAA;IACA,eAAA;EAmPR;EA7OE;IACE,WAAA;IACA,iBAAA;EA+OJ;EA5OE;IACE,YAAA;IACA,mBAAA;IACA,8BAAA;EA8OJ;EA1OE;IACE,iBAAA;EA4OJ;EAxOA;IACE,aAAA;EA0OF;AACF;AAvOA;EACE;IACE,YAAA;EAyOF;EAtOA;IACE,sBAAA;EAwOF;EAtOE;IACE,WAAA;IACA,sBAAA;EAwOJ;EArOE;IACE,UAAA;EAuOJ;EArOI;IAEE,gBAAA;IACA,YAAA;EAsON;EAnOI;IAEE,aAAA;IACA,kBAAA;EAoON;EAlOM;IACE,iBAAA;IACA,gBAAA;IAEA,iBAAA;EAmOR;EA/NI;IACE,YAAA;IACA,iBAAA;EAiON;EA/NM;IACE,UAAA;IACA,YAAA;IACA,cI1wBS;EJ2+BjB;EA7NI;IACE,eAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;EA+NN;EA7NM;IACE,aAAA;EA+NR;EA7NQ;IACE,cIzxBO;IJ0xBP,eAAA;IACA,iBAAA;EA+NV;EA3NM;IACE,aAAA;IACA,mBAAA;EA6NR;EA3NQ;IACE,qBAAA;IACA,cIryBO;IJsyBP,eAAA;IACA,iBAAA;EA6NV;EAxNQ;IACE,eAAA;IACA,kEAAA;IAIA,cIlzBO;EJygCjB;EA7MM;IACE,UAAA;IACA,eAAA;EA+MR;EAvMA;IAEE,UAAA;IACA,wBAAA;IAAA,mBAAA;EAwMF;EAtME;IACE,cI50Ba;IJ60Bb,eAAA;IACA,gBAAA;IACA,eAAA;EAwMJ;EAjMM;IACE,eAAA;IACA,kEAAA;IAIA,cIj2BK;EJiiCb;EA7LM;IACE,eAAA;IACA,mBAAA;IACA,cIv2BK;IJw2BL,gBAAA;EA+LR;EAzLM;IACE,mBAAA;IACA,YAAA;IACA,WAAA;EA2LR;EApLA;IACE,YAAA;EAsLF;EApLE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;EAsLJ;EAnLI;IACE,UAAA;IACA,eAAA;EAqLN;EA/KM;IACE,eAAA;IACA,UAAA;EAiLR;EA3KI;IACE,aAAA;IACA,mBAAA;IACA,WAAA;IACA,kBAAA;EA6KN;EA3KM;IACE,eAAA;IACA,kEAAA;EA6KR;EAvKM;IACE,cIh6BK;IJi6BL,eAAA;IACA,SAAA;EAyKR;EAtKM;IACE,kBAAA;IACA,wBAAA;IACA,YAAA;IACA,eAAA;EAwKR;EApKM;IAEE,eAAA;IACA,SAAA;EAqKR;EAjKM;IAEE,eAAA;IACA,SAAA;EAkKR;EA3JI;IACE,WAAA;EA6JN;EAvJA;IACE,aAAA;EAyJF;EAvJA;IACE,aAAA;EAyJF;EAtJA;IACE,aAAA;IACA,WAAA;IACA,6BAAA;IACA,eAAA;IACA,gBAAA;EAwJF;EAtJE;IACE,YAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;IACA,4BAAA;EAwJJ;EArJE;IACE,yBMrgCO;INsgCP,YAAA;EAuJJ;EApJE;IACE,yBIh+BS;IJi+BT,YAAA;IACA,iBAAA;IACA,aAAA;EAsJJ;EAjJA;IACE,aAAA;IACA,gBAAA;IACA,WAAA;IAEA,mBAAA;IACA,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;EAkJF;EA/IA;IACE,iBAAA;IACA,eAAA;IACA,kBAAA;IAEA,kBAAA;IACA,sBAAA;IACA,aAAA;EAgJF;EA7IA;IACE,aAAA;IACA,eAAA;IACA,QAAA;IACA,uBAAA;EA+IF;EA7IE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBAAA;IACA,eAAA;IACA,WAAA;IACA,wCAAA;EA+IJ;EA7II;IACE,yBAAA;EA+IN;EA5II;IACE,yBAAA;EA8IN;EA3II;IACE,yBAAA;EA6IN;EA1II;IACE,yBAAA;EA4IN;EAzII;IACE,gBAAA;IACA,eAAA;IACA,eAAA;IACA,WAAA;EA2IN;EAzIM;IACE,WAAA;EA2IR;EArIA;IACE,kBAAA;EAuIF;EAnIA;IACE,kBAAA;IACA,WAAA;IACA,uBAAA;IACA,8EAAA;IAEA,kBAAA;EAoIF;AACF;AA5HA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AA8HF;;AA3HA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AA8HF;;AA3HA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;AA8HF;;AA3HA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAEA,8BAAA;AA6HF;;AA1HA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AA6HF;;AA1HA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AA6HF;;AA1HA;EACE,WAAA;AA6HF;AA3HE;EACE,kBAAA;EACA,eAAA;AA6HJ;;AAzHA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AA4HF;AAzHE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA2HJ;;AAtHA;EACE,cAAA;EACA,WAAA;AAyHF;;AAtHA;EACE,eAAA;EACA,iCAAA;AAyHF;;AAtHA;EACE,yBMhsCW;ENisCX,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAyHF;AAvHE;EACE,YAAA;EACA,SAAA;AAyHJ;AAtHE;EACE,sBAAA;EACA,cM9sCS;ANs0Cb;AAtHI;EACE,cMjtCO;ANy0Cb;;AAnHA;EACE,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;AAsHF;AApHE;EACE,eAAA;AAsHJ;AAnHE;EACE,4CAAA;EACA,yCAAA;AAqHJ;AAlHE;EACE,yBMluCM;ENmuCN,gBAAA;AAoHJ;;AAhHA;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAmHF;;AAhHA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAmHF;;AAhHA;EACE,mBAAA;EACA,WAAA;EACA,aAAA;EAEA,yBAAA;EACA,qBAAA;AAkHF;AAhHE;EACE,uBAAA;AAkHJ;AA/GE;EACE,yBMrwCa;ANs3CjB;AA9GE;EACE,UAAA;AAgHJ;AA7GE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EAEA,YAAA;AA8GJ;AA7GI;EACE,kBAAA;EACA,SAAA;AA+GN;;AAzGA;EACE,aAAA;AA4GF;;AAzGA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AA4GF;;AAzGA;EACE,cIpwCa;EJqwCb,eAAA;EACA,YAAA;EACA,iBAAA;AA4GF;;AAzGA;EACE,YAAA;AA4GF;;AAzGA;EACE,eAAA;EACA,iBAAA;AA4GF;;AAzGA;EACE,eAAA;AA4GF;;AAzGA;EACE,eAAA;AA4GF;;AAzGA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,0CAAA;AA4GF;AA1GE;EACE,SAAA;EACA,cI5zCS;EJ6zCT,kBAAA;AA4GJ;AAzGE;EACE,cIj0CS;AJ46Cb;AAxGE;EACE,yBMr1Ca;ENs1Cb,YAAA;EACA,eAAA;AA0GJ;AAxGI;EACE,YAAA;AA0GN;AAtGE;EACE,yBM51CM;EN61CN,gBAAA;AAwGJ;;AApGA;;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;AAuGF;;AApGA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;AAuGF;;AApGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,eAAA;AAuGF;;AApGA;EAIE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBMz4CQ;EN04CR,YAAA;EACA,YAAA;AAoGF;AAlGE;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAoGJ;AAjGE;EACE,yBAAA;AAmGJ;AAhGE;EACE,yCAAA;EACA,gBAAA;AAkGJ;;AA9FA;EACE,YAAA;EACA,aAAA;AAiGF;;AAzFA;EACE,YAAA;EACA,aAAA;AA4FF;;AAzFA;EACE,WAAA;EACA,6BAAA;EACA,yBAAA;AA4FF;AA1FE;EACE,6BAAA;EACA,aAAA;EACA,UAAA;AA4FJ;AAzFE;EACE,aAAA;AA2FJ;AAzFI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;AA2FN;AAzFM;EACE,iBAAA;EACA,eAAA;EACA,cIr7CK;AJghDb;;AArFA;EACE,WAAA;EACA,iBAAA;AAwFF;;AArFA;EACE,aAAA;EAAc,uBAAA;EAAuB,YAAA;AA0FvC;;AAvFA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA0FF;;AAvFA;EACE,WAAA;EAAY,YAAA;EAAY,mBAAA;AA4F1B;;AAzFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBMz+CU;EN0+CV,gCAAA;EACA,mDAAA;EACA,mBAAA;EACA,eAAA;AA4FF;AA1FE;EACE,YAAA;EACA,gBAAA;AA4FJ;AAzFE;EACE,WMp/CS;ENq/CT,iBAAA;AA2FJ;;AAvFA;EACE,cIr+CW;AJ+jDb;;AAvFA;EACE,kBAAA;AA0FF;AAxFE;EACE,cI5+CS;AJskDb;;AAtFA;EACE,aAAA;EACA,eAAA;AAyFF;;AAtFA;EACE,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,YAAA;AAyFF;;AAtFA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;AAyFF;;AAtFA;EACE,2BAAA;EACA,gBAAA;AAyFF;;AAtFA;EACE,sBAAA;EACA,mBAAA;AAyFF;AAvFE;EACE,sBAAA;EACA,YAAA;AAyFJ;;AApFE;EACE,SAAA;AAuFJ;;AAnFA;EACE,cMxiDW;ENyiDX,mBAAA;AAsFF;;AAnFA;EACE,YAAA;AAsFF;;AAnFA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EAEA,iBAAA;EACA,6BAAA;AAqFF;AAnFE;EACE,uBAAA;EAAA,kBAAA;AAqFJ;;AAhFA;EACE,mBAAA;EAIA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAgFF;AA9EE;EACE,kBAAA;AAgFJ;AA7EE;EACE,iBAAA;AA+EJ;AA5EE;EACE,YAAA;EACA,eAAA;AA8EJ;;AA1EA;EACE,WM/lDW;ENgmDX,mBM1lDQ;ANuqDV;;AA1EA;EACE,WMpmDW;ENqmDX,mBMvmDW;ENwmDX,iBAAA;AA6EF;;AA1EA;EACE,WM1mDW;EN2mDX,mBMrmDQ;ENsmDR,YAAA;EACA,0CAAA;AA6EF;;AA3EA;EACE,cM5mDW;EN6mDX,mBI9jDgB;EJ+jDhB,YAAA;EACA,0CAAA;AA8EF;;AAzEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA4EF;;AAtEA;EACE,aAAA;AAyEF;;AArEA;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,+GAAA;EACA,kBAAA;EACA,UAAA;AAuEF;AAtEE;EACE,eAAA;AAwEJ;AAtEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAwEJ;;AAlEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAqEF;;AAlEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAqEF;;AAlEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AAqEF;AAnEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;AAqEJ;AAnEI;EACE,yBAAA;AAqEN;AAlEI;EACE,yBAAA;AAoEN;AAjEI;EACE,yBAAA;AAmEN;AAhEI;EACE,yBAAA;AAkEN;AA/DI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAiEN;AA/DM;EACE,WAAA;AAiER;;AA3DA;EACE,kBAAA;AA8DF;;AA3DA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,8EAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;AA8DF;;AA3DA;EACE,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cIlsDiB;EJmsDjB,sBAAA;AA8DF;AA3DE;EACE,eAAA;AA6DJ;;AAzDA;EACE,yBI3sDgB;EJ4sDhB,eAAA;AA4DF;;AApDA;EACE;IACE,8BAAA;EAuDF;EArDA;IACE,uBAAA;EAuDF;AACF;AApDA;EACE;IACE,oBAAA;EAsDF;EApDA;IACE,sBAAA;IACA,mBAAA;IACA,6BAAA;EAsDF;EApDA;IACE,mBAAA;IACA,gBAAA;IACA,uBAAA;EAsDF;EAnDA;IACE,kBAAA;IACA,YAAA;EAqDF;EAlDA;IACE,yBAAA;IACA,aAAA;EAoDF;EAjDA;IACE,uBAAA;EAmDF;AACF;AAhDA;EACE;IACE,sBAAA;EAkDF;EAhDA;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;EAkDF;EAhDA;IACE,WAAA;EAkDF;EA5CA;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;EA8CF;EA5CA;IACE,YAAA;EA8CF;EA5CA;IAEE,cAAA;EA6CF;EA1CA;IACE,uBAAA;EA4CF;AACF;AAxCA;EACE;IACE,sBAAA;EA0CF;EAxCA;IACE,iBAAA;IACA,sBAAA;EA0CF;EAxCE;IACE,mBAAA;EA0CJ;EAvCA;IACE,WAAA;EAyCF;EAvCA;IACE,uBAAA;EAyCF;AACF;AAtCA;EACE;IACE,WAAA;EAwCF;EArCA;IACE,sBAAA;IACA,mBAAA;EAuCF;EApCA;IACE,uBAAA;IAAA,kBAAA;IACA,eAAA;EAsCF;EAnCA;IACE,WAAA;IACA,eAAA;EAqCF;EAlCA;IACE,UAAA;IACA,iBAAA;EAoCF;EAjCA;IACE,YAAA;IACA,YAAA;IACA,SAAA;EAmCF;EAhCA;IACE,aAAA;IACA,sBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,mBAAA;EAkCF;EA/BA;IACE,WAAA;EAiCF;EA9BA;IACE,sBAAA;IACA,mBAAA;IACA,WAAA;IAEA,cAAA;EA+BF;EA9BE;IAEE,WAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;EA+BJ;EA3BA;;;;IAIE,YAAA;IACA,eAAA;EA6BF;EAzBA;IACE,YAAA;EA2BF;EAxBA;IACE,WAAA;EA0BF;EAnBA;IACE,gCAAA;EAqBF;EAlBA;IACE,cAAA;EAoBF;EAjBA;IACE,SAAA;IACA,WAAA;EAmBF;EAjBE;IACE,eAAA;EAmBJ;EAfA;IACE,cAAA;IACA,mBAAA;EAiBF;EAdA;IACE,SAAA;IACA,eAAA;IACA,eAAA;EAgBF;EAbA;IACE,aAAA;IACA,qBAAA;EAeF;EAbE;IACE,UAAA;EAeJ;EAbE;IACE,SAAA;EAeJ;EAbE;IACE,SAAA;EAeJ;EAXA;IACE,WAAA;IAAY,YAAA;EAcd;EAXA;IACE,YAAA;IACA,gBAAA;EAaF;EAXA;IACE,WAAA;EAaF;EAVA;IACE,wBAAA;EAYF;EATA;IACE,kBAAA;EAWF;EAPA;IACE,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,aAAA;IAEA,WAAA;IACA,uBAAA;IACA,0EAAA;IACA,kBAAA;IACA,uBAAA;IACA,sBAAA;EAQF;EANA;IACE,uBAAA;EAQF;AACF","sourcesContent":["@import '../../../styles.scss';\n@import \"/node_modules/flag-icons/css/flag-icons.min.css\";\n@import \"placeholders/fonts\";\n@import \"placeholders/flexboxes\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n\n.top-matter-container {\n  height: fit-content;\n  //width: 73dvw;\n  //background-color: red;\n}\n\n.interactive {\n  cursor: pointer;\n}\n\n.raised-footer {\n  display: flex;\n  justify-content: center;\n  padding: 4px;\n  background-color: #e1e3e4;\n  border-top: 1px solid #ddd;\n  width: 100%;\n}\n\n.view-toggle-btn {\n  padding: 10px 20px;\n  background-color: $accent-btn;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.view-toggle-btn:hover {\n  background-color: white;\n  color: $accent-btn;\n}\n\n\n// Retailer SCSS START\n.ret-profile-container {\n  display: flex;\n  flex-direction: column;\n  //width: 75vw;\n\n}\n\n.buttons-export {\n  display: flex;\n  justify-content: right;\n  width: 100%;\n  margin: 0 10% 0 0;\n\n  .button-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n\n  button {\n    border: none;\n    border-radius: 5px;\n    margin: 0 10px 0 0;\n    font-size: 15px;\n    padding: 7px 14px\n  }\n\n  .share-btn {\n    background-color: $theme-main;\n    color: white;\n    cursor: pointer;\n  }\n\n  .compare-btn {\n    background-color: $theme-accent;\n    color: white;\n    cursor: pointer;\n    display: flex;\n\n    span {\n      padding-left: 5px\n    }\n  }\n\n}\n\n.share-btn:hover {\n  opacity: 0.8;\n}\n\n.compare-btn:hover {\n  opacity: 0.8;\n}\n\n.buttons-export-mobile, .header-title-chips-mobile, .header-title-label-mobile, .selected-chips-mobile {\n  display: none\n}\n\n.topmatter {\n  display: flex;\n  background-color: white;\n  border-radius: 10px;\n  padding: 15px;\n  margin-bottom: 30px;\n}\n\n.mobilewrap-1 {\n  width: 30%;\n  min-width: 350px;\n  max-width: fit-content;\n  display: flex;\n\n}\n\n.col-1 {\n  display: flex;\n  flex-direction: column;\n  width: 40%;\n  min-width: 160px;\n\n  margin-right: 10px;\n\n  .col-1-top {\n    display: flex;\n    min-width: 160px;\n    flex-direction: column;\n    align-content: center;\n    width: 160px;\n  }\n\n  .logo {\n    display: flex;\n\n    align-items: center;\n    height: 150px;\n    border-radius: 5px;\n    //box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08), 0 6px 20px 0 rgba(0, 0, 0, 0.08);\n\n    //border: $theme-lightgray solid 1px;\n    padding: 5px;\n\n    .retailer-img {\n      max-height: 150px;\n      max-width: 150px;\n\n      object-fit: cover;\n    }\n  }\n\n  .social {\n    margin: 15px 5px 15px 5px;\n\n    svg {\n      width: 16.6%;\n      height: 20px;\n      color: $theme-back-light\n    }\n  }\n\n  .col-1-links {\n    width: 160px;\n    display: flex;\n    flex-direction: column;\n    align-items: left;\n    padding: 5px;\n\n  }\n\n  .lp {\n    display: flex;\n    align-items: center;\n\n    a {\n      text-decoration: none;\n      color: $theme-back-light;\n      font-size: 13px;\n      padding-left: 5px;\n\n    }\n  ;\n\n    span {\n      font-size: 15px;\n      font-variation-settings: 'FILL' 0,\n      'wght' 400,\n      'GRAD' 0,\n      'opsz' 24;\n      color: $theme-back-light\n    }\n  }\n\n  .corporation_name {\n    color: $theme-back-light;\n    font-size: 13px;\n\n    p {\n      text-align: left;\n    }\n  }\n}\n\n.col-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  padding: 0 10px 0 10px;\n  width: 60%;\n  max-width: 160px;\n\n  h1 {\n    color: $theme-back-light;\n    font-size: 25px;\n    font-weight: 600;\n    text-wrap: nowrap;\n  }\n\n  .details {\n\n    div {\n      display: flex;\n      align-items: center;\n      padding: 3px 0 3px 0;\n\n      span {\n        font-size: 20px;\n        font-variation-settings: 'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 11;\n        color: $theme-color5\n      }\n\n      p {\n        font-size: 15px;\n        margin: 3px 0 0 3px;\n        color: $theme-color5;\n        text-align: left;\n      }\n    }\n  ;\n\n    .hq {\n      img {\n        border-radius: 100%;\n        height: 13px;\n        width: 13px;\n        padding-left: 3px;\n        padding-right: 4px;\n      }\n    }\n\n  }\n}\n\n.mobilewrap-2 {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n\n}\n\n.col-3 {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding: 40px 20px 10px 0px;\n\n  .description {\n    p {\n      color: $theme-back-light;\n      font-size: 13px;\n      font-weight: 200;\n    }\n  }\n\n  .markets, .sector, .categories {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n    max-width: 100vw;\n\n    h3 {\n      color: $theme-back-light;\n      font-size: 13px;\n      font-weight: 500;\n      padding-right: 5px;\n      margin: 0;\n    }\n\n    p {\n      color: $theme-color5;\n      font-size: 13px;\n      margin: 0;\n    }\n  }\n;\n\n  .sector, .categories {\n    p {\n      background-color: #aaccff77;\n      padding: 2px 10px 2px 10px;\n      border-radius: 10px;\n      text-align: left;\n      text-wrap: nowrap;\n    }\n\n  }\n\n  .metrics {\n    display: flex;\n\n    div {\n      display: flex;\n    }\n  }\n\n  .metrics, .rankings {\n    display: flex;\n    margin-top: 15px;\n\n    div {\n      display: flex;\n      align-items: center;\n      width: 40%;\n      margin: 10px 10px 0 10px;\n\n      h3 {\n        color: $theme-back-light;\n        font-size: 12px;\n        font-weight: 500;\n        padding-right: 5px;\n        margin: 0;\n        width: 45%;\n        text-align: start;\n\n      }\n\n      span {\n        font-size: 12px;\n        font-variation-settings: 'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 24;\n        cursor: default;\n      }\n\n      p {\n        color: $theme-color5;\n        font-size: 12px;\n        margin: 0;\n\n\n      }\n\n      .value {\n        padding: 4px 5px 4px 5px;\n        width: 30%;\n\n      }\n\n      .negative {\n        color: red;\n        font-size: 8px;\n        padding: 0;\n        padding-left: 5px;\n      }\n\n      .positive {\n        color: #00b300;\n        font-size: 8px;\n        padding: 0;\n        padding-left: 5px;\n      }\n    }\n\n    .web-traffic {\n      .value {\n        background-color: #ffbf0012;\n        border-radius: 5px;\n        color: #d29e03\n      }\n    }\n\n    .revenue {\n      .value {\n        background-color: #0cad9a13;\n        border-radius: 5px;\n        color: #0CAD99\n      }\n    }\n\n    .profit {\n      .value {\n        background-color: #1b3f7817;\n        border-radius: 5px;\n        color: #1B3E78\n      }\n    }\n  }\n\n  .rankings {\n\n    .value {\n      background-color: #7d797911;\n      border-radius: 5px;\n      color: #7D7979\n    }\n\n    span {\n      margin-right: 20px\n    }\n  }\n\n\n}\n\n.products {\n  width: 75vw;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n\n  .products-title {\n    width: 100%;\n    text-align: center;\n    background-color: $theme-main;\n    color: white\n  }\n\n  .products-table, .product-row, .product-lists {\n    display: flex;\n    width: 100%;\n  }\n\n  .product-row {\n    width: 100%;\n    justify-content: space-between;\n\n  }\n\n  .product-sector {\n    width: 15%\n  }\n\n  .product-name {\n    width: 15%\n  }\n\n  .product-lists {\n    width: 70%\n  }\n\n}\n\n.mobilewrap-3 {\n  width: 15%;\n  display: flex;\n\n}\n\n.col-4-mobile {\n  display: none\n}\n\n.col-4 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 0px 10px 0px;\n  width: 100px;\n\n  .title {\n\n    h2 {\n      color: $theme-back-light;\n      font-size: 13px;\n      font-weight: 350\n    }\n  }\n\n  .list-button:hover {\n    cursor: pointer;\n    background-color: $theme-accent !important;\n    transition: all, 0.5s;\n\n    a {\n      color: white !important;\n      transition: all, 0.5s;\n    }\n  }\n\n\n  .buttons {\n    button {\n      background-color: white;\n      color: $theme-accent;\n      border: 2px solid $theme-accent;\n      border-radius: 5px;\n      margin-bottom: 3px;\n      padding: 5px;\n\n      a {\n        color: $theme-accent;\n        text-decoration: none;\n        font-size: 12px;\n      }\n    }\n\n  }\n\n  .vendor-social {\n    display: flex;\n    flex-direction: column;\n\n    div, a {\n      display: flex;\n      align-items: center;\n    }\n\n    a {\n      cursor: pointer;\n    }\n\n    span {\n      font-size: 15px;\n      margin-right: 5px;\n\n    }\n\n    p {\n      font-size: 10px\n    }\n  }\n}\n\n.echelon-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.echelon {\n  transition: width 0.3s ease;\n  margin-bottom: 30px;\n}\n\n.mobile {\n  display: none\n}\n\n.linkedin {\n  margin-top: 10px;\n\n  svg {\n    margin-right: 5px;\n  }\n}\n\n.email {\n  a {\n    text-decoration: none;\n  }\n\n  span {\n    color: black;\n  }\n}\n\n.tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n  margin-right: 20px;\n}\n\n.tooltip-trigger {\n  /*cursor: nw-resize;*/\n\n}\n\n.tooltip-box {\n  //top: 15%;\n  // left: 50%;\n  // transform: translate(20px, 20px);\n  position: fixed; /* or 'absolute' if you want it to follow a parent */\n  max-width: 200px;\n  background-color: white;\n  color: $theme-back-light;\n  padding: 16px 20px;\n  border-radius: 3px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);\n  font-size: 13px;\n  text-align: justify;\n  white-space: normal; /* ✅ Allow wrapping */\n  word-wrap: break-word; /* ✅ Wrap long words if needed */\n  overflow-wrap: break-word;\n  z-index: 1000; /* Make sure it's high enough */\n  pointer-events: none; /* Important: allows hover to still hit the trigger */\n  transition: opacity 0.2s ease;\n}\n\n.export-dropdown-container {\n  position: relative;\n\n}\n\n.export-dropdown, {\n  position: absolute;\n  z-index: 99;\n  background-color: white;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);\n  width: 250px;\n  border-radius: 3px;\n  transform: translateX(-33%); // Adjust back by half width\n\n}\n\n.export-btn-container {\n  padding: 16px 20px;\n  background-color: white;\n  color: $theme-back-light;\n\n\n  span {\n    font-size: 15px;\n  }\n}\n\n.export-btn-container:hover {\n  background-color: $theme-lightgray;\n  cursor: pointer;\n}\n\n.header-title-chips {\n  width: 100%;\n  padding: 10px;\n  border-radius: 12px;\n  position: relative;\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  text-align: center;\n  margin-right: 20px;\n}\n\n.header-title-label {\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0 20px;\n}\n\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n\n  .chip {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border-radius: 12px;\n    padding: 7px 10px;\n    font-size: 14px;\n    color: #333;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    &--retailer {\n      border: 2px solid $theme-main;\n    }\n\n    &--ranking {\n      border: 2px solid $theme-contrast;\n    }\n\n    &--sector {\n      border: 2px solid $theme-1;\n    }\n\n    &--cluster {\n      border: 2px solid $theme-2;\n    }\n\n    .remove-chip {\n      margin-left: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      color: #666;\n\n      &:hover {\n        color: #333;\n      }\n    }\n  }\n}\n\n@media (max-width: 1300px) {\n\n  .col-3 {\n    width: 30dvw;\n\n    .metrics, .rankings {\n      flex-wrap: wrap;\n      overflow: visible;\n    }\n  }\n;\n  .col-4-mobile {\n    display: flex;\n\n    .title {\n      display: flex;\n      align-items: center;\n      margin-top: 15px;\n\n      h2 {\n        color: $theme-back-light;\n        font-size: 13px;\n        font-weight: 350;\n        margin-right: 10px\n      }\n    }\n\n    .buttons {\n\n      button {\n        background-color: white;\n        color: $theme-accent;\n        border: 2px solid $theme-accent;\n        border-radius: 5px;\n        margin-bottom: 3px;\n        padding: 5px;\n\n        a {\n          color: $theme-accent;\n          text-decoration: none;\n          font-size: 12px;\n        }\n      }\n\n    }\n  }\n  .col-4 {\n    display: none\n  }\n}\n\n@media (max-width: 1000px) {\n  .ret-profile-container {\n    width: 70vw;\n  }\n\n  .topmatter {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .mobilewrap-1, .mobilewrap-2, .mobilewrap-3 {\n      width: 60vw\n\n    }\n\n    .mobilewrap-1 {\n\n    }\n\n    .col-3 {\n      padding: 0;\n\n      .metrics, .rankings {\n        h3, P {\n          width: 60%;\n          font-size: 11px;\n\n        }\n      }\n    }\n\n    .social {\n      width: 60vw;\n      padding-top: 15px;\n    }\n\n    .col-1-links {\n      width: 100vw;\n      flex-direction: row;\n      justify-content: space-between;\n\n    }\n\n    .list-button {\n      margin-left: 15px;\n    }\n  }\n\n  .col-3 {\n    width: 100dvw;\n  }\n}\n\n@media (max-width: 774px) {\n  .ret-profile-container {\n    width: 100vw;\n  }\n\n  .topmatter {\n    flex-direction: column;\n\n    .mobilewrap-1, .mobilewrap-2, .mobilewrap-3 {\n      width: 85vw;\n      padding: 2vw 5vw 0 5vw;\n    }\n\n    .col-1 {\n      width: 50%;\n\n      .col-1-top {\n\n        min-width: 150px;\n        width: 150px;\n      }\n\n      .logo {\n\n        height: 150px;\n        border-radius: 5px;\n\n        .retailer-img {\n          max-height: 140px;\n          max-width: 140px;\n\n          object-fit: cover;\n        }\n      }\n\n      .social {\n        width: 95dvw;\n        margin: 30% 0 0 0;\n\n        svg {\n          width: 15%;\n          height: 30px;\n          color: $theme-back-light\n        }\n      }\n\n      .col-1-links {\n        margin-top: 5vw;\n        width: 90vw;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n\n        .corporation_name {\n          display: flex;\n\n          p {\n            color: $theme-back-light;\n            font-size: 15px;\n            margin-left: 10px\n          }\n        }\n\n        .lp {\n          display: flex;\n          align-items: center;\n\n          a {\n            text-decoration: none;\n            color: $theme-back-light;\n            font-size: 18px;\n            padding-left: 5px;\n\n          }\n        ;\n\n          span {\n            font-size: 25px;\n            font-variation-settings: 'FILL' 0,\n            'wght' 400,\n            'GRAD' 0,\n            'opsz' 24;\n            color: $theme-back-light\n          }\n\n        }\n      }\n    }\n\n    .col-3 {\n\n      .metrics, .rankings {\n        h3, P {\n          width: 22%;\n          font-size: 11px;\n\n        }\n      }\n    }\n\n  }\n\n  .col-2 {\n\n    width: 50%;\n    height: fit-content;\n\n    h1 {\n      color: $theme-back-light;\n      font-size: 15px;\n      font-weight: 600;\n      text-wrap: wrap;\n    }\n\n    .details {\n\n      div {\n\n        span {\n          font-size: 20px;\n          font-variation-settings: 'FILL' 0,\n          'wght' 400,\n          'GRAD' 0,\n          'opsz' 11;\n          color: $theme-color5\n        }\n\n        p {\n          font-size: 12px;\n          margin: 3px 0 0 3px;\n          color: $theme-color5;\n          text-align: left;\n        }\n      }\n    ;\n\n      .hq {\n        img {\n          border-radius: 100%;\n          height: 15px;\n          width: 15px;\n        }\n      }\n\n    }\n  }\n\n  .col-3 {\n    width: 80dvw;\n\n    .metrics, .rankings, .categories {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n\n      h3, P {\n        width: 30%;\n        font-size: 11px;\n\n      }\n\n\n      .web-traffic, .profit, .revenue, .list-1, .list-2, .list-3 {\n        h3 {\n          font-size: 13px;\n          width: 22%;\n\n        }\n\n      }\n\n      div {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        margin: 0 0 10px 0;\n\n        span {\n          font-size: 15px;\n          font-variation-settings: 'FILL' 0,\n          'wght' 400,\n          'GRAD' 0,\n          'opsz' 24;\n        }\n\n        p {\n          color: $theme-color5;\n          font-size: 15px;\n          margin: 0;\n        }\n\n        .value {\n          text-align: center;\n          padding: 4px 5px 4px 5px;\n          width: 70dvw;\n          font-size: 13px;\n\n        }\n\n        .negative {\n\n          font-size: 12px;\n          width: 7%;\n\n        }\n\n        .positive {\n\n          font-size: 12px;\n          width: 7%;\n        }\n      }\n\n    }\n\n    .categories {\n      p {\n        margin: 5px;\n\n      }\n    }\n\n  }\n  .mobile {\n    display: flex\n  }\n  .buttons-export {\n    display: none\n  }\n\n  .buttons-export-mobile {\n    display: flex;\n    width: 75vw;\n    justify-content: space-evenly;\n    margin-top: 20%;\n    margin-left: 12%;\n\n    button {\n      border: none;\n      width: 33vw;\n      border-radius: 5px;\n      font-size: 15px;\n      padding: 10px 20px 10px 20px;\n    }\n\n    .share-btn {\n      background-color: $theme-main;\n      color: white;\n    }\n\n    .compare-btn {\n      background-color: $theme-accent;\n      color: white;\n      padding-left: 20%;\n      display: flex;\n    }\n\n  }\n\n  .header-title-chips-mobile {\n    padding: 10px;\n    margin-top: 20px;\n    width: 79vw;\n    //background-color: #fffaed;\n    border-radius: 12px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .header-title-label-mobile {\n    font-weight: bold;\n    font-size: 14px;\n    margin-bottom: 6px;\n\n    margin-right: auto; // push label to the left\n    align-self: flex-start; // aligns to the start of the flex column\n    display: flex\n  }\n\n  .selected-chips-mobile {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    justify-content: center;\n\n    .chip {\n      display: flex;\n      align-items: center;\n      background-color: white;\n      border-radius: 12px;\n      padding: 4px 10px;\n      font-size: 14px;\n      color: #333;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\n      &--retailer {\n        border: 2px solid $theme-main;\n      }\n\n      &--ranking {\n        border: 2px solid $theme-contrast;\n      }\n\n      &--sector {\n        border: 2px solid $theme-1;\n      }\n\n      &--cluster {\n        border: 2px solid $theme-2;\n      }\n\n      .remove-chip {\n        margin-left: 8px;\n        cursor: pointer;\n        font-size: 14px;\n        color: #666;\n\n        &:hover {\n          color: #333;\n        }\n      }\n    }\n  }\n\n  .export-dropdown-container-mobile {\n    position: relative;\n\n  }\n\n  .export-dropdown-mobile {\n    position: absolute;\n    z-index: 99;\n    background-color: white;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);\n\n    border-radius: 3px;\n\n  }\n}\n\n// Retailer SCSS END\n\n\n// List SCSS START\n.list-profile-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-left: 30px;\n}\n\n.list-top-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n.list-profile-header {\n  display: flex;\n  margin-bottom: 5px;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.list-banner {\n  display:flex;\n  width:100%;\n  flex-direction: row;\n  height:fit-content;\n  border: solid 1px $theme-accent;\n  border-radius: 25px;\n  padding: 20px;\n  background-color: white;\n\n  justify-content: space-between;\n}\n\n.list-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 15px;\n}\n\n.sponsor-area {\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  width:70%;\n}\n\n.sponsor-text-container {\n  height:30%;\n\n  p {\n    text-align:center;\n    font-size:12px\n  }\n}\n\n.sponsor-icon-container {\n  display:flex;\n  flex-direction:row;\n  justify-content: space-evenly;\n  flex-wrap:wrap;\n\n\n  img {\n    margin:10px;\n    max-height:40px;\n    min-width:45px;\n    width:80px;\n    object-fit: contain;\n\n  }\n}\n\n.like-profile {\n  grid-column: 3;\n  grid-row: 1;\n}\n\n.compare-profile, .share-profile {\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.compare-profile {\n  background-color: $theme-main;\n  color: white;\n  border: 2px solid $theme-main;\n  border-radius: 5px;\n  padding: 10px 20px;\n  margin-right: 10px;\n\n  p {\n    color: white;\n    margin: 0;\n  }\n\n  &:hover {\n    background-color: #fff;\n    color: $theme-main;\n\n    p {\n      color: $theme-main;\n    }\n  }\n}\n\n.share-profile {\n  border-radius: 100%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  margin-right: 30px;\n\n  span {\n    font-size: 40px;\n  }\n\n  &:hover {\n    box-shadow: 0 0 20px rgba($theme-contrast, 0.8);\n    background-color: rgba($theme-contrast, 0.3);\n  }\n\n  &:active {\n    background-color: $theme-3;\n    transition: none;\n  }\n}\n\n.list-cluster {\n  border-radius: 10px;\n  margin: 10px 0;\n  background-color: white;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n.list-cluster-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  width:100%;\n}\n\n.elite-table {\n  table-layout: fixed;\n  width:100%;\n  padding:0 5%;\n\n  border-collapse:separate;\n  border-spacing:0 1em;\n\n  tr:first-child {\n    background-color: white;\n  }\n\n  tr {\n    background-color: $app-background;\n  }\n\n  th {\n    width:14%;\n\n  }\n  .elite-td {\n    text-align: center;\n    align-items: center;\n    padding: 1px 0;\n    border-bottom:none;\n\n    margin:auto;\n    p {\n      text-align: center;\n      margin:0;\n    }\n  }\n\n}\n\n.list-cluster-title-container {\n  display:flex;\n}\n\n.list-cluster-title {\n  font-size: 25px;\n  margin: 10px;\n  font-weight:bold;\n}\n\n.list-cluster-title-name {\n  color:$theme-accent;\n  font-size: 25px;\n  margin: 10px;\n  font-weight:bold;\n}\n\n.retailer-logo {\n  height: auto;\n}\n\n.retailer-leading {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.retailer-top {\n  font-size: 13px;\n}\n\n.retailer-rest {\n  font-size: 11px;\n}\n\n.list-prof-pill {\n  border-radius: 10px;\n  margin: 3px;\n  padding: 5px 7px;\n  transition: background-color 0.3s ease-out;\n\n  p {\n    margin: 0;\n    color: $theme-back;\n    text-align: center;\n  }\n\n  a {\n    color: $theme-back;\n  }\n\n  &:hover {\n    background-color: $theme-contrast;\n    color:white;\n    cursor: pointer;\n\n    p {\n      color:white;\n    }\n  }\n\n  &:active {\n    background-color: $theme-3;\n    transition: none;\n  }\n}\n\n.list-lists,\n.list-other-clusters {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.list-name {\n  width: 100%;\n  max-height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  cursor: pointer;\n}\n\n.list-name-selector-form {\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  max-width: 55%;\n  max-height: 75%;\n}\n\n.list-name-selector {\n  @extend %font-20px-medium;\n  @extend %flex-column;\n  @extend %flex-jCenter-aCenter;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n  width: 225px;\n  padding: 10px;\n  border-radius: 15px;\n  transition: background-color 0.3s ease-out;\n  white-space: normal;\n  overflow-wrap: break-word !important;\n  background-color: $theme-1;\n  color:white;\n  border:none;\n\n  option {\n    font-size: 20px;\n    background-color: white;\n    text-wrap: wrap;\n    white-space: normal;\n  }\n\n  &:hover {\n    background-color: rgba($theme-lightgray, 1);\n  }\n\n  &:active {\n    background-color: rgba($theme-contrast, 0.8);\n    transition: none;\n  }\n}\n\n.flag-icon {\n  width: 250px;\n  height: 100px;\n}\n\n//img {\n//  width: 100px;\n//  height: 150px;\n//}\n\n.list-profile-container .chart {\n  width: 400px;\n  height: 600px;\n}\n\n.profile-table {\n  width: 100%;\n  border-bottom: 1px solid #ccc;\n  border-collapse: collapse;\n\n  td {\n    border-bottom: 1px solid #ccc;\n    padding: 10px;\n    width: 50%;\n  }\n\n  tr {\n    padding: 10px;\n\n    a {\n      display: flex;\n      align-items: center;\n      text-decoration: none;\n      width: fit-content;\n\n      span {\n        margin-right: 3px;\n        font-size: 20px;\n        color: $theme-back;\n      }\n    }\n  }\n}\n\n.table-container {\n  width:100%;\n  margin-left:30px;\n}\n\n.table-logo-container {\n  display:flex; justify-content:center;height:30px;\n}\n\n.table-logo {\n  display:block;\n  width:80px;\n  height:30px;\n  object-fit: contain;\n}\n\n.sm-flag-icon {\n  width:30px; height:30px;border-radius:100%;\n}\n\n.table-expand-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: $dark-text;\n  border-radius: 0px 0px 10px 10px;\n  box-shadow: 10px 10px 10px rgba($theme-lightgray, 0.7);\n  margin-bottom: 10px;\n  max-width: 95vw;\n\n  span {\n    color: white;\n    margin-left: 5px;\n  }\n\n  p {\n    color: $light-text;\n    font-weight: bold;\n  }\n}\n\nh1 {\n  color: $theme-back;\n}\n\n.heading {\n  text-align: center;\n\n  a {\n    color: $theme-back;\n  }\n}\n\n.pill-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.major-market-pill {\n  width: fit-content;\n  margin: 3px;\n  padding: 5px;\n}\n\n.echelon-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.echelon {\n  transition: width 0.3s ease;\n  margin-top: 20px;\n}\n\n.disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n\n  &:hover {\n    background-color: #ccc;\n    opacity: 0.5;\n  }\n}\n\n.crumbtrail {\n  p {\n    margin: 0;\n  }\n}\n\n.active-crumb {\n  color: $theme-main;\n  font-weight: bolder;\n}\n\n.inactive-crumb {\n  color: black;\n}\n\n.list-buttons {\n  display: flex;\n  flex-direction: row;\n  width:100%;\n  margin-top: 20px;\n  //align-items: flex-end;\n  margin-left: 30px;\n  justify-content: space-evenly;\n\n  div {\n    width:fit-content;\n  }\n\n}\n\n.rDNA-button {\n  border-radius: 15px;\n  @extend %font-20px-medium;\n  @extend %flex-column;\n  @extend %flex-jCenter-aCenter;\n  border: none;\n  font-size: 16px;\n  height: 48px;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  width:225px;\n\n  &:last-of-type {\n    margin-bottom: 5px;\n  }\n\n  span {\n    margin-left: 10px;\n  }\n\n  &:hover {\n    opacity: 0.8;\n    cursor: pointer;\n  }\n}\n\n.list-share-btn {\n  color: $light-text;\n  background: $theme-1;\n}\n\n.compare-btn {\n  color: $light-text;\n  background: $accent-btn;\n  margin-left: 10px;\n}\n\n.data-btn {\n  color: $light-text;\n  background: $theme-1; // New color for the Download Data button\n  border: none;\n  transition: background-color 0.3s ease-out;\n}\n.datalocked-btn {\n  color: $theme-main;\n  background: $theme-lightgray; // New color for the Download Data button\n  border: none;\n  transition: background-color 0.3s ease-out;\n}\n\n\n\n.padlock-container{\n  width:100%;\n  height:100%;\n  display:flex;\n  flex-direction: column;\n  align-items:center;\n  justify-content:center;\n  position:relative;\n\n\n\n}\n\n.padlock{\n  display:none\n\n}\n\n.padlock.disabled{\n\n  display:block;\n  width:100%;\n  height:100%;\n  display:flex;\n  flex-direction: column;\n  align-items:flex-end;\n  justify-content:left;\n  background: radial-gradient(circle,#4c4c4750 70%, #FFFFFF50 100%);\n  position:absolute;\n  z-index:2;\n  span{\n    font-size: 20px;\n  }\n  .link{\n    width:100%;\n    height:100%;\n    align-items: start;\n    justify-content: end;\n  }\n\n}\n\n\n.header-title-chips {\n  width: 100%;\n  padding: 10px;\n  border-radius: 12px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.header-title-label {\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0 20px;\n}\n\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n\n  .chip {\n    display: flex;\n    align-items: center;\n    background-color: white;\n    border-radius: 12px;\n    padding: 7px 10px;\n    font-size: 14px;\n    color: #333;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\n    &--retailer {\n      border: 2px solid $theme-main;\n    }\n\n    &--ranking {\n      border: 2px solid $theme-contrast;\n    }\n\n    &--sector {\n      border: 2px solid $theme-1;\n    }\n\n    &--cluster {\n      border: 2px solid $theme-2;\n    }\n\n    .remove-chip {\n      margin-left: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      color: #666;\n\n      &:hover {\n        color: #333;\n      }\n    }\n  }\n}\n\n.export-dropdown-container {\n  position: relative;\n}\n\n.export-dropdown-list {\n  position: absolute; // Changed from fixed to absolute\n  z-index: 99;\n  background-color: white;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.254), 0 3px 10px 0 rgba(0, 0, 0, 0.18);\n  border-radius: 3px;\n  left: 50%; // Center horizontally\n  transform: translateX(+3%); // Adjust back by half width\n  margin-top: 5px; // Optional spacing from the button\n}\n\n.export-btn-container-list {\n  width: 200px !important; // Fill the width of the parent (.export-dropdown)\n  padding: 16px 20px;\n  background-color: white;\n  color: $theme-back-light;\n  box-sizing: border-box;\n\n\n  span {\n    font-size: 15px;\n  }\n}\n\n.export-btn-container-list:hover {\n  background-color: $theme-lightgray;\n  cursor: pointer;\n}\n\n.list-export-dropdown-mobile {\n  //display:none !important;\n}\n\n\n@media screen and (min-width: $breakpoint-2-charts) {\n  .echelon-container {\n    justify-content: space-between;\n  }\n  .export-btn-container-list {\n    width: 201px !important;\n  }\n}\n\n@media screen and (max-width: $breakpoint-xl-max) {\n  .list-profile-header {\n    align-items: stretch;\n  }\n  .list-name {\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n  }\n  .list-buttons {\n    flex-direction: row;\n    align-items: top;\n    justify-content: center;\n  }\n\n  .list-share-btn {\n    margin-right: 10px;\n    width:225px;\n  }\n\n  .export-dropdown-list {\n    transform: translateX(+7%); // Adjust back by half width\n    margin-top: 0;\n  }\n\n  .export-btn-container-list {\n    width: 202px !important;\n  }\n}\n\n@media screen and (max-width: $breakpoint-lg-max) {\n  .list-name {\n    flex-direction: column;\n  }\n  .list-buttons {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .header-title-chips {\n    width: 66vw;\n  }\n\n  .selected-chips {\n    //flex-direction: column;\n  }\n  .buttons-container {\n    flex-direction:column;\n    align-items: center;\n    justify-content: center;\n  }\n  .list-share-btn, .rDNA-button {\n    width:350px;\n  }\n  .compare-btn {\n\n    margin-left: 0;\n  }\n\n  .export-btn-container-list {\n    width: 305px !important;\n  }\n\n}\n\n@media screen and (max-width: $breakpoint-md-max) {\n  .list-name {\n    flex-direction: column;\n  }\n  .list-buttons {\n    flex-wrap:nowrap;\n    flex-direction: column;\n\n    button {\n      margin: 5px 0 5px 0;\n    }\n  }\n  .header-title-chips {\n    width: 66vw;\n  }\n  .export-btn-container-list {\n    width: 305px !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .list-profile-container {\n    margin: 5px;\n  }\n\n  .list-name {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .list-name-selector-form {\n    width: fit-content;\n    max-width: 100%;\n  }\n\n  .list-name-selector {\n    width: 100%;\n    font-size: clamp(10px, 20px, 25px);\n  }\n\n  .list-logo {\n    width: 70%;\n    margin-left: 10px;\n  }\n\n  .flag-icon {\n    width: 200px;\n    height: 100%;\n    margin: 0;\n  }\n\n  .list-banner {\n    display:flex;\n    flex-direction:column;\n    height:fit-content;\n    align-items:center;\n  }\n\n  .sponsor-area {\n    width:90vw;\n  }\n\n  .list-buttons {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n\n    margin-left: 0;\n    div {\n\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      margin-bottom: 5px;\n    }\n  }\n\n  .rDNA-button,\n  .list-share-btn,\n  .compare-btn,\n  .data-btn {\n    width: 350px;\n    margin-right: 0;\n\n  }\n\n  .list-cluster {\n    width: 100vw;\n  }\n\n  .list-top-container {\n    width: 95vw;\n  }\n\n  //img{\n  //  margin-left: 25px;\n  //}\n\n  tr {\n    border-bottom: 1px solid rgba($theme-lightgray, 1);\n  }\n\n  .table-container {\n    margin-left:0;\n  }\n\n  .profile-table {\n    margin: 0;\n    width: auto;\n\n    th, td, span, p {\n      font-size: 11px;\n    }\n  }\n\n  .table-logo-container {\n    margin-left:0;\n    align-items: center;\n  }\n\n  .table-logo {\n    margin:0;\n    max-width: 100%;\n    max-height:60%;\n  }\n\n  .elite-table {\n    padding:0 1%;\n    word-wrap:break-word;\n\n    th {\n      width:15%;\n    }\n    th:first-child {\n      width: 7%;\n    }\n    th:last-child {\n      width: 7%;\n    }\n  }\n\n  .sm-flag-icon {\n    width:20px; height:20px;\n  }\n\n  .table-expand-button {\n    width:100vw;\n    max-width: 100vw;\n  }\n  .header-title-chips {\n    width: 95vw;\n  }\n\n  .export-dropdown-container {\n    display:none !important;\n  }\n\n  .list-export-dropdown-container-mobile {\n    position: relative;\n\n  }\n\n  .list-export-dropdown-mobile {\n    position: absolute; // Use absolute so it positions relative to the parent container\n    top: 100%; // Places it directly below the button\n    left: 50%; // Center horizontally\n    transform: translateX(-50%); // Shift it back by half its width\n    margin-top: 0;\n\n    z-index: 99;\n    background-color: white;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.254), 0 3px 10px rgba(0, 0, 0, 0.18);\n    border-radius: 3px;\n    width: 300px !important;\n    flex-direction: column;\n  }\n  .export-btn-container-list {\n    width: 300px !important;\n  }\n\n}\n\n// List SCSS END\n","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
